import React from 'react';
import styles from './ProductPackagingCheckDetails.module.scss';
import { useTranslation } from 'react-i18next';
import { DynamicComponentProps } from '@/types/ModuleComponentProp.type';

export const ProductPackagingCheckDetails: React.FC<DynamicComponentProps> = ({ inspection, structure }: DynamicComponentProps) => {
    const { t: translate } = useTranslation();

    return (
        <div className={styles.formContainer}>
            <h2 className={styles.header}>{translate(structure.header || 'Product Packaging Check Details')}</h2>
            <p><span className={styles.heading}>{translate('SKU')}</span> : <span className={styles.value}>{inspection.productReference}</span></p>
        </div>
    )
}